import { create } from 'zustand'
import { LANGUAGES, LOCALE } from '../utils/Utils'

const localeMap = {
  [LANGUAGES.TURKISH]: LOCALE.TR_TR,
  [LANGUAGES.ARABIC]: LOCALE.AR_SA,
  [LANGUAGES.ENGLISH]: LOCALE.EN_US
}

const localStorageLang = localStorage.getItem('lang')

const initialLang = (localStorageLang !== null && localStorageLang !== 'null') ? localStorageLang : LANGUAGES.ENGLISH

const useGlobalStore = create((set) => ({
  language: initialLang,
  locale: localeMap[initialLang],
  version: '',
  isLoggedIn: true,
  user: {},
  countries: JSON.parse(localStorage.getItem('countries')) ?? [],
  hsCodes: [], // TODO: hs kullanan yerler buradan beslenmeli, language değiştiğinde güncelleniyor
  campaignStatuses: {}, // campaign ID -> status mapping
  actions: {
    setUserData: (userData) => {
      set({ user: userData })
    },
    setLanguage: (language) => {
      const selectedLocale = localeMap[language]

      set({ language, locale: selectedLocale })
      localStorage.setItem('lang', language)
      localStorage.setItem('locale', selectedLocale)
    },
    setAppVersion: (version) => {
      set({ version })
    },
    setCountries: (countries) => {
      set({ countries })
    },
    setLoggedInStatus: (isLoggedIn) => {
      set((state) => {
        if (state.isLoggedIn !== isLoggedIn) {
          return { isLoggedIn }
        }
        return { isLoggedIn: state.isLoggedIn }
      })
    },
    setHsCodes: (hsCodes) => {
      set({
        hsCodes
      })
    },
    setCampaignStatus: (campaignId, status) => {
      set((state) => ({
        campaignStatuses: {
          ...state.campaignStatuses,
          [campaignId]: status
        }
      }))
    },
    setCampaignStatuses: (statusesMap) => {
      set((state) => ({
        campaignStatuses: {
          ...state.campaignStatuses,
          ...statusesMap
        }
      }))
    }
  }
}))

const dataGetter = (key) => useGlobalStore((state) => state[key])

export const useGlobalStoreData = {
  language: () => dataGetter('language'),
  locale: () => dataGetter('locale'),
  version: () => dataGetter('version'),
  isLoggedIn: () => dataGetter('isLoggedIn'),
  user: () => dataGetter('user'),
  countries: () => dataGetter('countries'),
  hsCodes: () => dataGetter('hsCodes'),
  campaignStatuses: () => dataGetter('campaignStatuses')
}

export const useGlobalStoreActions = () => useGlobalStore((state) => state.actions)

export const useCampaignStatus = (campaignId) => useGlobalStore((state) => state.campaignStatuses[campaignId])

export default useGlobalStore
